import Vue from "vue";

Vue.filter("dateFormat", value => {
  if (!value) return "";
  const date = new Date(value);
  return date.toLocaleDateString();
});

Vue.filter("removeTime", value => {
  if (!value) return "";
  const date = value.split(" ");
  return date[0];
});
